import { render, staticRenderFns } from "./Particles.vue?vue&type=template&id=f9cf0efe&"
import script from "./Particles.vue?vue&type=script&lang=js&"
export * from "./Particles.vue?vue&type=script&lang=js&"
import style0 from "./Particles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports